import { EnrollmentProcess } from '@/models/EnrollmentProcess';
import { Person } from '@/models/Person';
import { ProgramClass } from '@/models/ProgramClass';

export enum ProgramClassTypes {
    CREATE_PROGRAM_CLASS_FOR_COURSE_REQUEST = '@programClass/CREATE_PROGRAM_CLASS_FOR_COURSE_REQUEST',
    CREATE_PROGRAM_CLASS_FOR_PROGRAM_REQUEST = '@programClass/CREATE_PROGRAM_CLASS_FOR_PROGRAM_REQUEST',
    CREATE_PROGRAM_CLASS_SUCCESS = '@programClass/CREATE_PROGRAM_CLASS_SUCCESS',
    CREATE_PROGRAM_CLASS_FAILURE = '@programClass/CREATE_PROGRAM_CLASS_FAILURE',
    CREATE_PROGRAM_CLASS_CLEAR = '@programClass/CREATE_PROGRAM_CLASS_CLEAR',
    UPDATE_PROGRAM_CLASS_REQUEST = '@programClass/UPDATE_PROGRAM_CLASS_REQUEST',
    UPDATE_PROGRAM_CLASS_SUCCESS = '@programClass/UPDATE_PROGRAM_CLASS_SUCCESS',
    UPDATE_PROGRAM_CLASS_FAILURE = '@programClass/UPDATE_PROGRAM_CLASS_FAILURE',
    UPDATE_PROGRAM_CLASS_CLEAR = '@programClass/UPDATE_PROGRAM_CLASS_CLEAR',
    DELETE_PROGRAM_CLASS_REQUEST = '@programClass/DELETE_PROGRAM_CLASS_REQUEST',
    DELETE_PROGRAM_CLASS_SUCCESS = '@programClass/DELETE_PROGRAM_CLASS_SUCCESS',
    DELETE_PROGRAM_CLASS_FAILURE = '@programClass/DELETE_PROGRAM_CLASS_FAILURE',
    DELETE_PROGRAM_CLASS_CLEAR = '@programClass/DELETE_PROGRAM_CLASS_CLEAR',
    GET_PROGRAM_CLASS_REQUEST = '@programClass/GET_PROGRAM_CLASS_REQUEST',
    GET_PROGRAM_CLASS_SUCCESS = '@programClass/GET_PROGRAM_CLASS_SUCCESS',
    GET_PROGRAM_CLASS_TO_UPDATE_ENROLLMENTS_SUCCESS = '@programClass/GET_PROGRAM_CLASS_TO_UPDATE_ENROLLMENTS_SUCCESS',
    GET_PROGRAM_CLASS_FAILURE = '@programClass/GET_PROGRAM_CLASS_FAILURE',
    GET_PROGRAM_CLASS_CLEAR = '@programClass/GET_PROGRAM_CLASS_CLEAR',
    GET_ENROLLED_STUDENTS_REQUEST = '@programClass/GET_ENROLLED_STUDENTS_REQUEST',
    GET_ENROLLED_STUDENTS_SUCCESS = '@programClass/GET_ENROLLED_STUDENTS_SUCCESS',
    GET_ENROLLED_STUDENTS_FAILURE = '@programClass/GET_ENROLLED_STUDENTS_FAILURE',
    GET_ENROLLED_STUDENTS_CLEAR = '@programClass/GET_ENROLLED_STUDENTS_CLEAR',
    GET_ENROLLMENT_BY_STUDENT_REQUEST = '@programClass/GET_ENROLLMENT_BY_STUDENT_REQUEST',
    GET_ENROLLMENT_BY_STUDENT_SUCCESS = '@programClass/GET_ENROLLMENT_BY_STUDENT_SUCCESS',
    GET_ENROLLMENT_BY_STUDENT_FAILURE = '@programClass/GET_ENROLLMENT_BY_STUDENT_FAILURE',
    GET_ENROLLMENT_BY_STUDENT_CLEAR = '@programClass/GET_ENROLLMENT_BY_STUDENT_CLEAR',
    ENROLL_STUDENT_REQUEST = '@programClass/ENROLL_STUDENT_REQUEST',
    ENROLL_STUDENT_SUCCESS = '@programClass/ENROLL_STUDENT_SUCCESS',
    ENROLL_STUDENT_FAILURE = '@programClass/ENROLL_STUDENT_FAILURE',
    ENROLL_STUDENT_CLEAR = '@programClass/ENROLL_STUDENT_CLEAR',
    UNENROLL_STUDENT_REQUEST = '@programClass/UNENROLL_STUDENT_REQUEST',
    UNENROLL_STUDENT_SUCCESS = '@programClass/UNENROLL_STUDENT_SUCCESS',
    UNENROLL_STUDENT_FAILURE = '@programClass/UNENROLL_STUDENT_FAILURE',
    UNENROLL_STUDENT_CLEAR = '@programClass/UNENROLL_STUDENT_CLEAR',
    GET_STUDENTS_WITH_ENROLL_INFO_REQUEST = '@programClass/GET_STUDENTS_WITH_ENROLL_INFO_REQUEST',
    GET_STUDENTS_WITH_ENROLL_INFO_SUCCESS = '@programClass/GET_STUDENTS_WITH_ENROLL_INFO_SUCCESS',
    GET_STUDENTS_WITH_ENROLL_INFO_FAILURE = '@programClass/GET_STUDENTS_WITH_ENROLL_INFO_FAILURE',
    GET_STUDENTS_WITH_ENROLL_INFO_CLEAR = '@programClass/GET_STUDENTS_WITH_ENROLL_INFO_CLEAR',
    MASS_IMPORT_ENROLLMENT_REQUEST = '@programClass/MASS_IMPORT_ENROLLMENT_REQUEST',
    MASS_IMPORT_ENROLLMENT_SUCCESS = '@programClass/MASS_IMPORT_ENROLLMENT_SUCCESS',
    MASS_IMPORT_ENROLLMENT_FAILURE = '@programClass/MASS_IMPORT_ENROLLMENT_FAILURE',
}

export interface ProgramClassState {
    data: ProgramClass[];
    currentData: ProgramClass;
    students: PersonWithEnrollment[];
    enrollments: ClassEnrollment[];
    enrollment?: ClassEnrollment;
    enrollmentsProcess: EnrollmentProcess[];
    loading: boolean;
    success: boolean;
    hasError: boolean;
    updatingEnrollmentsCount: boolean;
}

export type StudentsRequestOrderBy = 'person.firstName, person.lastName';
export interface StudentsRequestData {
    offset: number;
    limit: number;
    search?: string | null;
    programClassId: number;
    onlyActive: boolean;
    orderBy?: StudentsRequestOrderBy;
}

export interface PersonWithEnrollment {
    person: Person;
    enrolled: boolean;
    classEnrollmentId: number;
    enrolledInAnotherClass: boolean;
    automaticEnroll: boolean;
}

export interface ClassEnrollment {
    id: number;
    person: Person;
    personId: number;
    programClass: ProgramClass;
}

export interface EnrollmentProcessData {
    filename: string;
    applicationId: number;
    organizationId: number;
    programClassId: number;
    multipleClassEnrollmentMode?: boolean;
}
